import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import CampaignContext from '@/product/context/campaign/campaignContext'
import UserContext from '@/product/context/user/userContext'
import Loaders from '@/product/components/molecules/Loaders'

const CampaignManage = (props) => {
    const settingContext = useContext(SettingContext)
    const campaignContext = useContext(CampaignContext)
    const {
        all_users,
        getAllUsers,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(UserContext)

    const {
        single_configuration,
        getSingleConfiguration,
        configurationAction,
    } = settingContext
    const {
        getAllCampaigns,
        campaignAction,
        all_templates,
        changeCampaignStatus,
        all_campaigns,
        getCampaignTemplates,
        responseStatus: responseStatusCampaign,
        clearResponse: clearResponseCampaign,
    } = campaignContext

    const [product, setProduct] = useState(null)
    const [usersList, setUsersList] = useState([])
    const [activeTemplates, setActiveTemplates] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        campaign_name: Yup.string().required('Required!'),
        campaign_to: Yup.string().required('Required'),
        from_name: Yup.string().required('Required!'),
        from_email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        subject: Yup.string().required('Required!'),
        subject_preview: Yup.string().required('Required!'),
        campaign_template_id: Yup.string(),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            campaign_name: '',
            campaign_to: '',
            from_name: '',
            from_email: '',
            subject: '',
            subject_preview: '',
            campaign_template_id: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            campaignAction(values)
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (data.status === 'edit' && data.id) {
            setIsLoading(true)
            let id = data.id
            getAllCampaigns(
                {
                    searchterm: '',
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    filters: {
                        id: {
                            value: id,
                            type: 'in',
                            field: 'cpn.id',
                        },
                    },
                },
                'editValues'
            )
            // getAllUsers({
            //     limit: 20,
            //     page: 1,
            //     orderby: '',
            //     order: '',
            //     filters: {
            //         status: {
            //             value: 'active',
            //             type: 'in',
            //             field: 'u.status',
            //         },
            //         admin: {
            //             value: '0',
            //             type: 'in',
            //             field: 'u.admin',
            //         },
            //     },
            // })
        } else {
            getAllUsers({
                limit: 20,
                page: 1,
                orderby: '',
                order: '',
                filters: {
                    status: {
                        value: 'active',
                        type: 'in',
                        field: 'u.status',
                    },
                    admin: {
                        value: '0',
                        type: 'in',
                        field: 'u.admin',
                    },
                },
            })
            getCampaignTemplates({
                searchterm: '',
                page: 1,
                limit: 20,
                order: '',
                orderby: '',
                filters: {
                    active: {
                        value: '1',
                        type: 'in',
                        field: 'ct.is_active',
                    },
                    template: {
                        value: 'template',
                        type: 'in',
                        field: 'ct.type',
                    },
                },
            })
            resetFrom()
        }
    }, [data.popup])

    useEffect(() => {
        if (
            all_campaigns.records &&
            data.status === 'edit' &&
            all_campaigns.from === 'editValues'
        ) {
            if (all_campaigns.records.length) {
                const template = all_campaigns.records[0]
                formik.values.id = template.id
                formik.values.campaign_name = template.campaign_name
                formik.values.campaign_to = template.campaign_to
                formik.values.from_name = template.from_name
                formik.values.from_email = template.from_email
                formik.values.subject = template.subject
                formik.values.subject_preview = template.subject_preview
                formik.values.campaign_template_id =
                    template.campaign_template_id
                setIsLoading(false)
            }
        } else {
            resetFrom()
            setIsLoading(false)
        }
    }, [all_campaigns])

    useEffect(() => {
        if (all_users) {
            setUsersList(all_users.records.length ? all_users.records : [])
        }
    }, [all_users])

    useEffect(() => {
        if (all_templates) {
            setActiveTemplates(
                all_templates.records.length ? all_templates.records : []
            )
        }
    }, [all_templates])

    useEffect(() => {
        if (responseStatusCampaign) {
            if (
                responseStatusCampaign.from === 'CAMPAIGN_ACTION' &&
                responseStatusCampaign.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                getAllCampaigns(
                    {
                        searchterm: '',
                        page: 1,
                        limit: 20,
                        order: '',
                        orderby: '',
                        filters: {
                            active: {
                                value: 1,
                                type: 'in',
                                field: 'cpn.is_active',
                            },
                        },
                    },
                    'allCampaigns'
                )
            }
        }
    }, [responseStatusCampaign])

    const resetFrom = () => {
        formik.values.id = 0
        formik.values.campaign_name = ''
        formik.values.campaign_to = ''
        formik.values.from_name = ''
        formik.values.from_email = ''
        formik.values.subject = ''
        formik.values.subject_preview = ''
        formik.values.campaign_template_id = ''
        formik.handleReset()
    }

    const emailTemplate = []

    emailTemplate.push(
        {
            label: 'Campaign Name',
            placeholder: 'Enter Campaign name',
            class: 'col-md-6 col-sm-6 col-12',
            type: 'text',
            shrink: true,
            name: 'campaign_name',
            formik: formik,
        },
        // {
        //     label: 'To',
        //     placeholder: 'Select Users',
        //     class: 'col-12 mb-4',
        //     type: 'select',
        //     options: usersList.map((maincat) => {
        //         let categoryChanged = {}
        //         categoryChanged.show = maincat.email
        //         categoryChanged.value = maincat.email
        //         return categoryChanged
        //     }),
        //     shrink: true,
        //     name: 'campaign_to',
        //     formik: formik,
        // },
        {
            content: 'To',
            type: 'misc',
            class: 'col-md-12 mb-2',
        },
        {
            label: 'To',
            placeholder: 'Select Users',
            class: 'col-sm-6 col-12',
            type: 'select',
            options: [{ show: 'Active Users', value: 'active_users' }],
            shrink: true,
            name: 'campaign_to',
            formik: formik,
        },
        {
            content: 'From',
            type: 'misc',
            class: 'col-md-12 mb-2',
        },
        {
            label: 'Name',
            placeholder: 'From name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'from_name',
            formik: formik,
        },
        {
            label: 'Email',
            placeholder: 'From Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'from_email',
            formik: formik,
        },
        {
            type: 'misc',
            content: 'Subject',
            class: 'col-md-12 mb-2',
        },
        {
            label: 'Subject Line',
            placeholder: 'Enter the subject line for this campaign',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'textarea',
            name: 'subject',
            formik: formik,
        },
        {
            label: 'Subject Preview',
            placeholder: 'Enter the subject preview for this campaign',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'textarea',
            name: 'subject_preview',
            formik: formik,
        },
        {
            type: 'misc',
            content: 'Content',
            class: 'col-md-12 mb-2',
        },
        {
            label: 'Templates',
            placeholder: 'Select Templates',
            class: 'col-sm-6 col-12',
            type: 'select',
            name: 'campaign_template_id',
            options: activeTemplates.map((maincat) => {
                let categoryChanged = {}
                categoryChanged.show = maincat.title
                categoryChanged.value = maincat.id
                return categoryChanged
            }),
            formik: formik,
        }
    )

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'ADD Campaign' : `EDIT Campaign`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            {isLoading ? (
                <div className="fieldsLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <div className="addUserModal">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {Object.values(mapData(emailTemplate))}
                            </div>

                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="configManage_cancel"
                                    label="Cancel"
                                    onClick={() => toggleFullScreenPopup(false)}
                                />
                                <PrimaryButton
                                    id="campaign_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </FullScreenPopup>
    )
}

export default CampaignManage
